import React, { useContext, useEffect, useState } from "react";

import {
	Avatar,
	Box,
	Divider,
	IconButton,
	InputAdornment,
	ListItem,
	ListItemAvatar,
	ListItemText,
	OutlinedInput,
	Skeleton,
	Typography,
} from "@mui/material";

import Drawer from "@mui/material/Drawer";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SendIcon from "@mui/icons-material/Send";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import StopCircleIcon from "@mui/icons-material/StopCircle";

import { DrawerHeaderRight } from "./Appbar";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../../GlobalContext";
import { initChat, sendMessage } from "../../utils/Gemini";

export const Right = ({ title, component }) => {
	const { openRight, handlerSideRight } = useContext(GlobalContext);

	const location = useLocation();

	const [chat, setChat] = useState({});

	// eslint-disable-next-line
	const [model, setModel] = useState({});
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");

	useEffect(() => {
		if (openRight) {
			const { model, chat } = initChat();

			setChat(chat);
			setModel(model);
		}
	}, [openRight]);

	return (
		<>
			<Drawer
				open={openRight}
				sx={{
					overflow: "hidden",
					width: 400,
					flexShrink: 0,
					"& .MuiDrawer-paper": {
						width: 400,
						color: "#fff",
					},
				}}
				variant="persistent"
				anchor="right"
			>
				<DrawerHeaderRight>
					<IconButton
						sx={{ color: "#fff" }}
						onClick={() => handlerSideRight(false, location.pathname.replace("/", ""))}
					>
						{openRight ? <ChevronLeftIcon /> : <ChevronRightIcon />}
					</IconButton>

					<Typography
						variant="h6"
						sx={{
							position: "absolute",
							left: 50,
							color: "#fff",
							fontSize: "24px",
							fontWeight: 700,
							textTransform: "uppercase",
						}}
					>
						Asistente (beta)
					</Typography>
				</DrawerHeaderRight>

				<Divider />

				<Box sx={{ p: 2, overflow: "hidden", color: "#fff" }}>
					<Box
						sx={{
							p: 1,
							border: (theme) => `1px solid ${theme.palette.divider}`,
							borderRadius: 1,
							height: "calc(100vh - 262px)",
							overflowY: "auto",
							color: "#fff",
						}}
					>
						{chat?._history?.map((msg, index) => (
							<Box key={index}>
								{msg?.role === "model" && (
									<ListItem alignItems="flex-start">
										<ListItemAvatar>
											<AutoAwesomeIcon sx={{ color: "#fff" }} />
										</ListItemAvatar>

										<ListItemText
											secondary={msg?.parts[0]?.text}
											secondaryTypographyProps={{
												sx: { color: "#fff" },
											}}
										/>
									</ListItem>
								)}

								{msg?.role === "user" && (
									<ListItem alignItems="flex-start">
										<ListItemText
											secondary={msg?.parts[0]?.text}
											secondaryTypographyProps={{
												sx: { color: "#fff" },
											}}
										/>

										<ListItemAvatar>
											<Avatar
												sx={{
													bgcolor: "transparent",
													border: "1px solid rgba(255,255,255,0.3)",
												}}
											/>
										</ListItemAvatar>
									</ListItem>
								)}
							</Box>
						))}

						{loading && (
							<Box sx={{ p: 1 }}>
								<Skeleton />
								<Skeleton />
								<Skeleton />
								<Skeleton width={"60%"} />
							</Box>
						)}
					</Box>

					<OutlinedInput
						sx={{
							mt: 2.5,
							color: "#fff",
							"& .MuiOutlinedInput-notchedOutline": {
								borderColor: "rgba(255,255,255,0.3)",
							},
							"&:hover .MuiOutlinedInput-notchedOutline": {
								borderColor: "rgba(255,255,255,0.5)",
							},
							"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
								borderColor: "#fff",
							},
							"& textarea": {
								color: "#fff",
							},
							"& textarea::placeholder": {
								color: "rgba(255,255,255,0.7)",
								opacity: 1,
							},
							"& .MuiInputAdornment-root": {
								color: "#fff",
							},
						}}
						multiline
						rows={4}
						placeholder="En que puedo ayudarte?"
						value={message}
						onChange={(e) => setMessage(e.target.value)}
						fullWidth
						endAdornment={
							<InputAdornment position="end">
								{loading ? (
									<IconButton sx={{ color: "#fff" }} disabled={loading} onClick={() => setLoading(false)}>
										<StopCircleIcon />
									</IconButton>
								) : (
									<IconButton
										sx={{ color: "#fff" }}
										disabled={loading}
										onClick={() => {
											sendMessage(setLoading, chat, setChat, message);
											setMessage("");
										}}
									>
										<SendIcon />
									</IconButton>
								)}
							</InputAdornment>
						}
					/>
				</Box>
			</Drawer>
		</>
	);
};
